import React from 'react';
import {Box, ButtonBase, Grow, Paper, Typography} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import {formatDate, formatPeso} from "../../helpers";
import Strings from "../../assets/strings";
import estadoPrestamo from "../../styles/estadoPrestamo";
import {ESTADO_PRESTAMO, getValueString, SITUACION_PRESTAMO} from "../../helpers/CONSTANTES";
import {SelectEnum} from "../selects";

const useStyles = makeStyles(theme => ({
  root: {
    background: "#f5f5f5",
    display: "block",
    margin:5,
    // borderBottom: "1px solid" +theme.palette.grey[300],
    ...estadoPrestamo(theme),
    "& .content":{
      display:"flex",
      justifyContent:"space-between",
      // padding:theme.spacing(1),
      "& .estado":{
        border: "1px solid",
        fontSize: "11px",
        padding: "3px 7px",
        borderRadius: "10px",
      }
      // [theme.breakpoints.only('xs')]: {
      //   overflow: "auto",
      // },
    }
  },
  divider:{
    margin: theme.spacing(1) +" 0px",
  },
  details:{
    "&>div":{
      display:"flex",
      justifyContent:"space-between",
      [theme.breakpoints.down(undefined)]: {
        "&:first-child":{
          flexDirection:"column-reverse",
        },
        flexDirection: "column"
      }

    }
  }
}));
export default function ItemPrestamo({ onClick,timeout=0,item:pre }) {
  const classes = useStyles();
  return (
      <>
        {pre &&
            <Grow in timeout={timeout}>
              <ButtonBase component={Paper} elevation={1} className={classes.root +" estado"+pre.estado+" situacion"+pre.situacion} onClick={onClick}>
                <Box  className="content" >
                    <Box flexGrow={1} padding={1} >

                      <Box
                           sx={{
                             display: "table",
                             tableLayout: "fixed",
                             width: "100%",
                             borderBottom: "1px solid #ccc",
                             marginBottom:"5px"
                           }}
                      >
                        <Typography variant={"subtitle1"} noWrap>{pre.cliente}</Typography>
                      </Box>

                      <Typography variant={"caption"}>
                        <span>{Strings.proximo} {Strings.pago}:</span>
                        <Box component={"span"} display={"inline-block"} minWidth={115}> {formatDate(pre.fechaProximoPago,"dd, DD MMMM, YYYY")} </Box>

                      </Typography> <br/>
                      <Typography variant="caption">
                        <span>{Strings.balance} {Strings.pendiente}: </span>

                        <Box component={"span"} display={"inline-block"} minWidth={87}> {formatPeso(pre.balancePendiente)}</Box>


                      </Typography> <br/>
                      <Typography variant="caption">
                        {Strings.modalidad+": "}
                        <SelectEnum
                            group="ciclosPago"
                            value={pre.ciclosPago}
                        />
                      </Typography>
                    </Box>
                    <Box sx={{
                      paddingLeft: 2, paddingRight: 1,
                      textAlign: "center", minWidth:"114px", width: "114px", padding: "20px 8px 20px 14px", borderLeft: "1px solid #cacaca",}}>
                      <Typography variant="caption">{Strings.cuotas} {pre.plazoString}</Typography>
                      <Typography variant="subtitle1">{formatPeso(pre.montoCuota)}</Typography>
                      <Box className={"estado"}>
                        {pre.estado === ESTADO_PRESTAMO.ACTIVO ? (
                                <>{getValueString(SITUACION_PRESTAMO, pre.situacion)}</>
                            ):(
                                <>{getValueString(ESTADO_PRESTAMO, pre.estado)}</>
                        )}

                        {(pre.estado === ESTADO_PRESTAMO.ACTIVO && pre.situacion === SITUACION_PRESTAMO.CUOTAS_VENCIDA) && ": "+pre.cuotasAtrasadas}
                      </Box>

                    </Box>
                  {/*<Box display="flex" justifyContent="space-between">*/}
                  {/*  <Typography component={"span"} noWrap>{pre.cliente}</Typography>*/}
                  {/*  <HtmlTooltip title={Strings.monto+" "+Strings.cuotas}>*/}
                  {/*  <Typography align={"right"}>*/}
                  {/*      /!*<Typography variant="caption">Cuotas:</Typography>*!/*/}
                  {/*      {formatPeso(pre.montoCuota)}*/}
                  {/*  </Typography>*/}
                  {/*  </HtmlTooltip>*/}
                  {/*</Box>*/}
                  {/*<div style={{margin:"8px 0",borderBottom:"1px dashed #cacaca"}}/>*/}
                  {/*<div className={classes.details}>*/}
                  {/*  <div>*/}
                  {/*    <Typography variant="caption">{Strings.balance} {Strings.pendiente}: {formatPeso(pre.balancePendiente)}</Typography>*/}
                  {/*    <HtmlTooltip title={Strings.proximo+" "+Strings.pago}>*/}
                  {/*      <Typography variant="body2">{*/}
                  {/*        formatDate(pre.fechaProximoPago,"dd, DD MMMM, YYYY")*/}
                  {/*           .replace(", "+new Date().getFullYear(),"")*/}
                  {/*      }*/}
                  {/*      </Typography>*/}
                  {/*    </HtmlTooltip>*/}
                  {/*  </div>*/}
                  {/*  <div>*/}
                  {/*    <div>*/}
                  {/*      <Typography variant="caption" noWrap>*/}
                  {/*        {Strings.cuotas} {Strings.pagada}: {pre.plazoString}*/}
                  {/*      </Typography>*/}
                  {/*      <Typography variant="caption" component={"div"} noWrap>*/}
                  {/*        {Strings.c_pendientes}: {pre.cuotasAtrasadas}*/}
                  {/*        /!*{pre.cuotasAtrasadas>1 && pre.cuotasAtrasadas}  {Strings[pre.estadoString]}*!/*/}
                  {/*      </Typography>*/}
                  {/*    </div>*/}

                  {/*    <Typography variant="caption" className="estado">*/}
                  {/*      {(pre.estadoString === "mora" || pre.estadoString === "c_pendientes") ?(*/}
                  {/*          <>{Strings.mora} : {formatPeso(pre.mora)}</>*/}
                  {/*      ):(*/}
                  {/*          <>   {pre.cuotasAtrasadas>1 && pre.cuotasAtrasadas}  {translateText(pre.estadoString)}</>*/}
                  {/*      )}*/}
                  {/*      /!*{Strings[pre.estado]}*!/*/}


                  {/*    </Typography>*/}
                  {/*  </div>*/}
                  {/*</div>*/}
                </Box>
              </ButtonBase>
            </Grow>
        }
      </>
  )
}
